import { render, staticRenderFns } from "./bolt_general_tab.vue?vue&type=template&id=637cb8d3&scoped=true&"
import script from "./bolt_general_tab.vue?vue&type=script&lang=js&"
export * from "./bolt_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637cb8d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637cb8d3')) {
      api.createRecord('637cb8d3', component.options)
    } else {
      api.reload('637cb8d3', component.options)
    }
    module.hot.accept("./bolt_general_tab.vue?vue&type=template&id=637cb8d3&scoped=true&", function () {
      api.rerender('637cb8d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/bolt/location/tabs/bolt_general_tab.vue"
export default component.exports